import {AuditAreaTemplate, UpsertAuditAreaTemplate} from "platformed-client/types";
import {platformedClient} from "..";
import {invalidateQueries, q} from "../../state";

export async function list(): Promise<AuditAreaTemplate[]> {
  return platformedClient.internalRequest("get", "/region/{region}/api/tprm/audit_area_templates", {});
}

export async function replaceAll(templates: UpsertAuditAreaTemplate[]): Promise<void> {
  await platformedClient.internalRequest("put", "/region/{region}/api/tprm/audit_area_templates", {body: templates});

  await invalidateQueries([q.tprm.auditAreaTemplates.filter()]);
}
